module.exports = __webpack_public_path__ + "assets/img/00052.0c86cdab.png";